import { IconBtn } from 'ctls/inputs/IconBtn';
import { useDisplayTarget } from 'hooks/useDisplayTarget';
import { tc } from 'language/i18nkey';
import { ChkInput } from 'pages/dlcenter/leftpanel/comp/ChkInput';
import styled from 'styled-components';
import { ColGrp } from 'uiutil/ColGrp';
import { formatDate } from 'util/formatDateTime';
import { countrylang } from 'util/langutil';
import { BRKS } from 'util/variables';
import { DocGrpItemId } from './PopDocGrpSett';
import { DiffLevel, DocGrpDiffInfo } from './useApiDocGrp';
import { useCompareDocGrp } from './useCompareDocGrp';

type Props = {
  sels: DocGrpItemId[];
  idKoKr: number | undefined;
  idEn: number | undefined;
  idEnUs: number | undefined;

  onChangeSels: (sels: DocGrpItemId[]) => void;
};

type DiffVal = string | boolean | number | null;
const getDiffScore = (a: DiffVal, b: DiffVal, c: DiffVal): number => {
  let score = 0;
  if (a === b) score += 1;
  if (a === c) score += 1;
  if (b === c) score += 1;
  return score; // 3 이면 동일, 1이면 두개가 같음, 0이면 모두 다름.
};
export const TblCompareItem = (props: Props) => {
  const { sels, onChangeSels } = props;

  const { diffLevel, diffLevels, koKr, en, enUs } = useCompareDocGrp(sels, props.idKoKr, props.idEn, props.idEnUs);

  // const {data: list} = useSWR<DocGrpDiffInfo[]>(['/api/member/zdata/docgrpmppng/diffsByDocIds', {docIds: [props.idKoKr, props.idEn, props.idEnUs]}]);

  // const koKr = list?.find(item => item.lang === 'ko-KR');
  // const en = list?.find(item => item.lang === 'en');
  // const enUs = list?.find(item => item.lang === 'en-US');

  const { getDisplayTargetStr } = useDisplayTarget();

  // const scoreVersion = getDiffScore(koKr?.version, en?.version, enUs?.version);
  // const scoreUpdate = getDiffScore(koKr?.updateTime, en?.updateTime, enUs?.updateTime);
  // const scoreExpose = getDiffScore(koKr?.expose, en?.expose, enUs?.expose);
  // const scoreDisplayTarget = getDiffScore(koKr?.displayTarget, en?.displayTarget, enUs?.displayTarget);

  const handleClickDocId = (info: DocGrpDiffInfo) => {
    //const url = docurl(info.docType, info.docId);
    const url = countrylang('/community/new/' + info.docId);
    window.open(url, '_blank');
    //window.open(`/docwrite/community/docgrp/doc?docId=${docId}`, '_blank');
  };

  const getDiffCls = (diffLevel: DiffLevel) => {
    if (diffLevel === 'Similar') return 'color_y';
    if (diffLevel === 'Different') return 'color_r';
    return '';
  };
  return (
    <Body>
      <Table>
        <ColGrp cols={[1, 1, 1, 1]} />
        <thead>
          <Tr>
            <Th>{tc('i18n_division')}</Th>
            <Th>
              <ChkInput
                label={tc('i18n_korea')}
                checked={sels.includes('ko-KR')}
                setChecked={() => {
                  onChangeSels(sels.includes('ko-KR') ? sels.filter((item) => item !== 'ko-KR') : [...sels, 'ko-KR']);
                }}
              />
            </Th>
            <Th>
              <ChkInput
                label={tc('i18n_global')}
                checked={sels.includes('en')}
                setChecked={() => {
                  onChangeSels(sels.includes('en') ? sels.filter((item) => item !== 'en') : [...sels, 'en']);
                }}
              />
            </Th>
            <Th>
              <ChkInput
                label={tc('i18n_usa')}
                checked={sels.includes('en-US')}
                setChecked={() => {
                  onChangeSels(sels.includes('en-US') ? sels.filter((item) => item !== 'en-US') : [...sels, 'en-US']);
                }}
              />
            </Th>
          </Tr>
        </thead>
        <tbody>
          <Tr>
            <Td>{tc('i18n_doc_id')}</Td>
            <Td>
              <div className='flex items-center'>
                {koKr?.docId} <IconBtn btnType='link' show={!!koKr?.docId} onClick={() => handleClickDocId(koKr)} />
              </div>
            </Td>
            <Td>
              <div className='flex items-center'>
                {en?.docId} <IconBtn btnType='link' show={!!en?.docId} onClick={() => handleClickDocId(en)} />
              </div>
            </Td>
            <Td>
              <div className='flex items-center'>
                {enUs?.docId} <IconBtn btnType='link' show={!!enUs?.docId} onClick={() => handleClickDocId(enUs)} />
              </div>
            </Td>
          </Tr>
          <Tr className={getDiffCls(diffLevels?.version)}>
            <Td>
              <ChkInput
                label={tc('i18n_version')}
                checked={sels.includes('version')}
                setChecked={() => {
                  onChangeSels(
                    sels.includes('version') ? sels.filter((item) => item !== 'version') : [...sels, 'version']
                  );
                }}
              />
            </Td>
            <Td>{koKr?.version}</Td>
            <Td>{en?.version}</Td>
            <Td>{enUs?.version}</Td>
          </Tr>
          <Tr className={getDiffCls(diffLevels?.updateTime)}>
            <Td>
              <ChkInput
                label={tc('i18n_update')}
                checked={sels.includes('update')}
                setChecked={() => {
                  onChangeSels(
                    sels.includes('update') ? sels.filter((item) => item !== 'update') : [...sels, 'update']
                  );
                }}
              />
            </Td>
            <Td>{koKr?.updateTime ? formatDate(new Date(koKr?.updateTime)) : '-'}</Td>
            <Td>{en?.updateTime ? formatDate(new Date(en?.updateTime)) : '-'}</Td>
            <Td>{enUs?.updateTime ? formatDate(new Date(enUs?.updateTime)) : '-'}</Td>
          </Tr>
          <Tr className={getDiffCls(diffLevels?.fileCnt)}>
            <Td>
              <ChkInput
                label={tc('i18n_attachment')}
                checked={sels.includes('file')}
                setChecked={() => {
                  onChangeSels(sels.includes('file') ? sels.filter((item) => item !== 'file') : [...sels, 'file']);
                }}
              />
            </Td>
            <Td>{koKr?.fileCnt}</Td>
            <Td>{en?.fileCnt}</Td>
            <Td>{enUs?.fileCnt}</Td>
          </Tr>
          <Tr className={getDiffCls(diffLevels?.expose)}>
            <Td>
              <ChkInput
                label={tc('i18n_expose_state')}
                checked={sels.includes('expose')}
                setChecked={() => {
                  onChangeSels(
                    sels.includes('expose') ? sels.filter((item) => item !== 'expose') : [...sels, 'expose']
                  );
                }}
              />
            </Td>
            <Td>{koKr?.expose === true ? tc('i18n_open') : koKr?.expose === false ? tc('i18n_no_open') : '-'}</Td>
            <Td>{en?.expose === true ? tc('i18n_open') : en?.expose === false ? tc('i18n_no_open') : '-'}</Td>
            <Td>{enUs?.expose === true ? tc('i18n_open') : enUs?.expose === false ? tc('i18n_no_open') : '-'}</Td>
          </Tr>
          <Tr className={getDiffCls(diffLevels?.displayTarget)}>
            <Td>
              <ChkInput
                label={tc('i18n_target')}
                checked={sels.includes('disp-target')}
                setChecked={() => {
                  onChangeSels(
                    sels.includes('disp-target')
                      ? sels.filter((item) => item !== 'disp-target')
                      : [...sels, 'disp-target']
                  );
                }}
              />
            </Td>
            <Td>{getDisplayTargetStr(koKr?.displayTarget)}</Td>
            <Td>{getDisplayTargetStr(en?.displayTarget)}</Td>
            <Td>{getDisplayTargetStr(enUs?.displayTarget)}</Td>
          </Tr>
        </tbody>
      </Table>
    </Body>
  );
};

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: #2a2c2f;
  font-size: 1.3rem;
  font-weight: 500;
`;

const Tr = styled.tr`
  &.color_y {
    background-color: #f7b91b1a;
  }

  &.color_r {
    background-color: #e6003e1a;
  }
`;

const Th = styled.th`
  border-top: 1px solid #d5d8e5;
  border-bottom: 1px solid #d5d8e5;
  padding: 0rem 0.8rem;
  line-height: 5.2rem;
  background-color: #d5d8e5;
  @media (max-width: ${BRKS.mobileMax}) {
    padding: 0;
  }
`;

const Td = styled.td`
  border-top: 1px solid #d5d8e5;
  border-bottom: 1px solid #d5d8e5;
  padding: 0rem 0.8rem;
  line-height: 5.2rem;
  vertical-align: middle;
  @media (max-width: ${BRKS.mobileMax}) {
    padding: 0;
  }
`;

const Body = styled.div`
  border-radius: 0.8rem;
  //padding: 1.6rem;
`;
